import React from 'react'
import { Box, CardContent, CardMedia, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import { demoProfilePicture } from '../utils/constants';
import { margin } from '@mui/system';

const ChannelCard = ({channelDetail, marginTop}) => {
  return (
    <box
      sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: {xs: '356px', md: '320px'}, margin: 'auto' }}
    >
      <Link to={`/channel/${channelDetail?.id?.channelId}`}>
        <CardContent sx={{display:'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#fff', marginTop: marginTop}}>
          <CardMedia 
            image={channelDetail?.snippet?.thumbnails?.high?.url || demoProfilePicture}
            alt={channelDetail?.snippet?.title}
            sx={{borderRadius:'50%', height:'180px', width: '180px', mb: 2, border: '1px solid #e3e3e3'}} />
            <Typography variant='h6'>
              {channelDetail?.snippet?.title}
              <CheckCircleIcon sx={{fontSize:'17px', ml: '5px', color:'gray'}}/>
            </Typography>
            <Typography>
              {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString()} Subscribers
            </Typography>
        </CardContent>
      </Link>
    </box>
  )
}

export default ChannelCard